// Autogenerated file
export const authProvidersEnum = {
    AtiSu: "AtiSu",
};
export const authProviders = [
    { label: "ATI.SU", value: "AtiSu" },
];
